export const SOCKET_CONNECTING = Symbol.for('SOCKET_CONNECTING');
